import styled from "styled-components";

export const UsefulLinksItemSideTextBox = styled.div`
    display: inline-block;
    margin-left: auto;
    margin-right: 25px;
`;